import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Reveal } from "@/components/Reveal";

export default function Brands() {
  const { t } = useApp();
  return (
    <section id="work" className="relative py-28 lg:py-40 bg-background" data-testid="work-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[1.03] max-w-3xl">{t.work.title}</h2>
          <p className="mt-6 text-muted-foreground max-w-xl leading-relaxed">{t.work.sub}</p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {t.work.items.map((b, i) => (
            <Reveal key={b.n} delay={(i % 3) * 0.06}>
              <div className="group relative bg-card p-8 h-full min-h-[200px] flex flex-col justify-between hover:bg-secondary transition-colors" data-testid={`brand-card-${i}`}>
                <div className="flex items-start justify-between">
                  <span className="font-display text-3xl md:text-4xl tracking-tight group-hover:text-cyan transition-colors">{b.n}</span>
                  <ArrowUpRight className="w-5 h-5 text-slate group-hover:text-brass group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
                </div>
                <p className="mt-8 text-sm text-muted-foreground leading-relaxed">{b.d}</p>
                <div className="mt-5 h-px w-0 bg-cyan group-hover:w-full transition-all duration-500" />
              </div>
            </Reveal>
          ))}
          <div className="bg-navy text-white p-8 flex flex-col justify-center min-h-[200px]" data-testid="brand-card-cta">
            <p className="font-mono text-[10px] tracking-[0.28em] uppercase text-cyan mb-3">Independent installer</p>
            <p className="font-display text-2xl leading-tight">Factory-current, brand-agnostic — the right kit for your boat.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
